import React, { useState, useEffect, useRef } from "react";
import { calcBillTotals } from "../../../core/utils/salesTotals";
import { useForm, useFieldArray } from "react-hook-form";
import { Link } from "react-router-dom";
import { DatePicker } from "antd";
import Select from "react-select";
import { ArrowDown, Calendar } from "feather-icons-react/build/IconComponents";
import {
  getSupplierList,
  getTaxList,
  getDiscountList,
  getUnitList,
  getDiscountbyguid,
} from "../../../services/MasterApiServices";
import PlusCircle from "feather-icons-react/build/IconComponents/PlusCircle";
import { getProductList } from "../../../services/MasterApiServices";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelector } from "react-redux";
import { PurchaseClass } from "../../../core/json/Purchase";
import { PurchaseDetailClass } from "../../../core/json/PurchaseDetail";
import toast from "react-hot-toast";
import {
  addEditPurchase,
  getPurchaseByTransType,
} from "../../../services/PurchaseApiService";
import SupplierModal from "../../master/modal/SupplierModal";
import { ProductClass } from "../../../core/json/Product";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";
import { DiscountClass } from "../../../core/json/Discount";
import { TaxClass } from "../../../core/json/TaxClass";
import { useDispatch } from "react-redux";
import {
  fetchUnit,
  fetchProduct,
  fetchTax,
  fetchSupplier,
  fetchSettings,
} from "../../../redux/userSetting";
import { FinancialYear } from "../../../core/json/FinancialYear";

const PurchaseInvoiceModal = ({ mode, data, handleClose, handleRefresh }) => {
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    watch,
    control,
    reset,
    formState: { errors }, 
    
  } = useForm({
    defaultValues: {
      date: dayjs().format("YYYY-MM-DD"),
      deliveryDate: dayjs().format("YYYY-MM-DD"),
      invoiceDate: dayjs().format("YYYY-MM-DD"),
      duedate: dayjs().format("YYYY-MM-DD"),
      addition: 0,
      subtraction: 0,
      round: 0,
    },
    mode: "onBlur",
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUnit());
    dispatch(fetchProduct(branch));
    dispatch(fetchTax());
    dispatch(fetchSettings(branch));
    const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
    const currfmt = match ? match[0]?.length - 1 : 0;
    setDecimalPoints(currfmt);
    dispatch(fetchSupplier());
  }, []);

  const [taxData, setTaxData] = useState([]);
  const [discountData, setdiscountData] = useState([]);
  const [unitData, setunitData] = useState([]);
  const [supplierData, setSupplierData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [isRowAdded, setIsRowAdded] = useState(false);
  const [decimalpoints, setDecimalPoints] = useState(2);

  const [products, setProducts] = useState([]);
  const [discountList, setdiscountList] = useState([]);
const [printAfterSubmit, setPrintAfterSubmit] = useState(false); // Flag to track if print is requested
  // Get user from redux
  const { userId } = useSelector((state) => state.userauth);
  const { branchsettings } = useSelector((state) => state.settings);
  const { companyInfolist } = useSelector((state) => state.companyInfo);

    const [purchaseData, setPurchaseData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
   const refNo = watch("refNo");
    const referenceTypeValue = watch("referenceType");
   const [fetchOrder, setFetchOrder] = useState(false);


  const { productList, unitList, taxList, supplierList, settingList } =
    useSelector((state) => state.usersetting);

  // Get branch from redux
  const { branch } = useSelector((state) => state.branchlist);

  const paymentType = [
    { value: 0, label: "Cash" },
    { value: 1, label: "Card" },
    { value: 2, label: "Bank" },
    { value: 3, label: "Credit" },
    { value: 4, label: "UPI" },
  ];
  const referenceType = [
    { value: 0, label: "Direct" },
    { value: 1, label: "Order" },
    { value: 2, label: "Goods Receipt" },
  ];
  const purchaseTransType = [
    { value: 0, label: "Order" },
    { value: 1, label: "Goods Receipt" },
    { value: 2, label: "Invoice" },
    { value: 3, label: "Return" },
  ];

  //Calculations ---------------
  const safeNumber = (value, defaultValue = 0) => {
    // Check for null, undefined, or empty string and use the default value
    if (value === null || value === undefined || value === "") {
      return defaultValue;
    }

    // Convert to number
    const num = Number(value);

    // Return the number or the default value if num is NaN
    return isNaN(num) ? defaultValue : num;
  };
  const selectRef = useRef(null);
  const focusProduct = () => {
    setTimeout(() => {
      if (selectRef.current) {
        selectRef.current.focus();
      }
    }, 0);
  };

  useEffect(() => {
    focusProduct();
  }, []);
  const rowUseForm = getValues("row") || [];

  let totalGross = 0;
  let totalDiscount = 0;
  let totalTax = 0;
  let totalNet = 0;

  // VAT the ZATCA way, the same on every document screen and print
  // (core/utils/salesTotals.js, = the API's Zatca/SalesTotals.cs): the bill
  // discount (subtraction) and the addition change the taxable amount, and VAT
  // is worked out on what is left. Lines get their share of the VAT.
  const addition = Number(watch(`addition`, 0));
  const subtraction = Number(watch(`subtraction`, 0));
  const round = Number(watch(`round`, 0));
  const billCalc = calcBillTotals(
    fields.map((field, index) => ({
      quantity: watch(`items[${index}].quantity`, 0),
      price: watch(`items[${index}].price`, 0),
      discountPercent: watch(`items[${index}].discountPercentage`, 0),
      taxPercent: watch(`items[${index}].taxPercentage`, 0),
    })),
    {
      billDiscount: safeNumber(subtraction),
      addition: safeNumber(addition),
      roundOff: safeNumber(round),
      decimals: Number(decimalpoints) >= 0 ? Number(decimalpoints) : 2,
    }
  );
  billCalc.lines.forEach((t, index) => {
    setValue(`items[${index}].gross`, t.gross?.toFixed(decimalpoints));
    setValue(`items[${index}].discountAmount`, t.discount?.toFixed(decimalpoints));
    setValue(`items[${index}].taxAmount`, t.tax?.toFixed(decimalpoints));
    setValue(`items[${index}].netTotal`, t.net?.toFixed(decimalpoints));
  });
  totalGross = billCalc.gross;
  totalDiscount = billCalc.discountTotal;
  totalTax = billCalc.tax;
  totalNet = billCalc.net;
  //end-------------
  function handleRemove(index) {
    if (fields.length > 1) {
      remove(index);
    } else {
      toast.error("At least one product entry is required");
    }
  }

  const handleUnitList = async () => {
    try {
      const response = await getUnitList();
      const formattedUnit = response?.map((unit) => ({
        label: unit.name,
        value: unit.guid,
      }));
      setunitData(formattedUnit);
    } catch (error) {
      console.error(
        "Error fetching unit",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };
  const handleTaxList = async () => {
    try {
      const formattedTax = taxList?.map((tax) => ({
        label: tax.percentage,
        value: tax.percentage,
        guid: tax.guid,
      }));
      setTaxData(formattedTax);
    } catch (error) {
      console.error(
        "Error fetching tax",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleDiscountList = async () => {
    try {
      const response = await getDiscountList();

      const formattedDiscount = response?.map((discount) => ({
        label: discount.percentage,
        value: discount.percentage,
        guid: discount.guid,
      }));
      setdiscountData(formattedDiscount);
      setdiscountList(response);
    } catch (error) {
      console.error(
        "Error fetching discount",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleEachProductfetch = async (selectedOption, index) => {
    setValue(`items[${index}].product`, selectedOption.value);

    try {
      const productData = await getSingleProduct(selectedOption.value);

      setValue(`items[${index}].code`, productData?.code || 0);
      setValue(`items[${index}].hsnCode`, productData?.hsnCode || 0);
      setValue(`items[${index}].unit`, productData?.unit.guid || 0);
      setValue(`items[${index}].price`, productData?.cost || 0);
    } catch (error) {
      console.error(
        "Error fetching product by GUID:",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  async function getSingleProduct(guid) {
    try {
      const filteredData = productList?.filter(
        (product) => product.guid === guid
      );
      return filteredData[0];
    } catch (error) {
      console.error("Error fetching products", error);
    }
  }

  const handleSupplierList = async () => {
    try {
      const formattedSuppliers = supplierList?.map((supplier) => ({
        label: supplier.name,
        value: supplier.guid,
      }));
      setSupplierData(formattedSuppliers);
    } catch (error) {
      console.error("Error fetching suppliers", error);
    }
  };

  // Fetch purchase invoices data
//   const handleEntryNo = async () => {
//     try {
//       const response = await getPurchaseByTransType(branch, 2);
//       const purchaseData = response.data;
//       // Find the maximum number from the existing entries
//       const maxEntryNumber =
//         purchaseData?.length > 0
//           ? purchaseData
//               ?.map((data) => parseInt(data.entrynumber.replace(/\D/g, ""))) // Extract and parse numbers
//               .reduce((max, num) => Math.max(max, num), 0) // Find the maximum number
//           : 0;
//       let counter = maxEntryNumber + 1;
//       setValue(`entrynumber`, `PI${counter}`);
//       counter++;
//      // console.log("Parsed Numbers:", numbers);
// console.log("Max Number:", maxEntryNumber);
// console.log("New Entry No:", `PI${maxEntryNumber + 1}`);

//     } catch (error) {
//       console.error("Failed to fetch purchase invoices", error);
      
//     }
//   };

const handleEntryNo = async () => {
  try {
    const response = await getPurchaseByTransType(branch, 2);
    const purchaseData = response.data;

    // Extract valid numbers from entry numbers
    const numbers = purchaseData
      ?.map((item) => {
        const match = item?.entrynumber?.match(/\d+/); // safely extract digits
        return match ? parseInt(match[0], 10) : null;
      })
      .filter((num) => !isNaN(num)); // filter out bad values

    const maxEntryNumber = numbers.length > 0 ? Math.max(...numbers) : 0;

    const newEntryNo = `PI${maxEntryNumber + 1}`;
    setValue("entrynumber", newEntryNo);

    console.log("Generated Entry No:", newEntryNo);
  } catch (error) {
    console.error("Failed to fetch purchase invoices", error);
  }
};

  
  useEffect(() => {
    if (mode === "add") {
      handleEntryNo();
      if (!isRowAdded && fields?.length === 0) {
        handleAddRow();
        setIsRowAdded(true);
      }
    }

    handleProductsList();

    handleTaxList();
    handleUnitList();
    handleDiscountList();
  }, []);

  
    function resetmodal() {
      console.log(mode);
    if (mode === "edit" && data) {
      const mappedItems = data?.purchaseDetails?.map((detail) => ({
        product: detail?.product?.guid || null,
        code: detail?.product?.code || "",
        hsnCode: detail?.product?.hsnCode || "",
        batch: detail.batch || "",
        expiry: dayjs(detail.expiry),
        unit: detail.unit?.guid || null,
        quantity: detail.quantity || 0,
        price: detail.price || 0,
        mrp: detail.mrp || 0,
        foc: detail.foc || 0,
        discountPercentage: detail.discount?.percentage || null,
        discountAmount: detail.discountAmount || 0,
        taxPercentage: detail.tax?.percentage || null,
        gross: detail.gross || 0,
        taxAmount: detail.taxAmount || 0,
        netTotal: detail.netTotal || 0,
      }));
  
      reset({
        entrynumber: data.entrynumber || "",
        remarks: data.remarks || "",
        refNo: data.refNo || "",
        shipmentNo: data.shipmentNo || "",
        shipmentTerms: data.shipmentTerms || "",
        invoiceNo: data.invoiceNo || "",
        addition: data.addition || 0,
        subtraction: data.discount || 0,
        round: data.roundOff || 0,
        grossTotal: data.grossTotal || 0,
        discountTotal: data.discountTotal || 0,
        taxTotal: data.taxTotal || 0,
        netTotal: data.netTotal || 0,
        paymentType: data.purchasePaymentType || 0,
        referenceType: data.referenceType || 0,
        supplier: data.supplier?.guid || null,
        date: dayjs(data.date) || dayjs(),
        invoiceDate: dayjs(data.invoiceDate) || dayjs(),
        duedate: dayjs(data.duedate) || dayjs(),
        
        items: mappedItems?.length > 0 ? mappedItems : [getBlankItem()],
      });
    } else {
      reset({
        
        remarks: "",
        refNo: "",
        shipmentNo: "",
        shipmentTerms: "",
        invoiceNo: "",
        addition: 0,
        subtraction: 0,
        round: 0,
        grossTotal: 0,
        discountTotal: 0,
        taxTotal: 0,
        netTotal: 0,
        paymentType: 0,
        referenceType: 0,
        supplier: null,
        date: dayjs(),
        invoiceDate: dayjs(),
        duedate: dayjs(),
        items: [getBlankItem()],
      });
      handleEntryNo();
    }
    
  }
  function getBlankItem() {
    return {
      product: null,
      code: "",
      hsnCode: "",
      batch: "",
      expiry: dayjs(),
      unit: null,
      quantity: 0,
      price: 0,
      mrp: 0,
      foc: 0,
      discountPercentage: null,
      discountAmount: 0,
      taxPercentage: null,
      gross: 0,
      taxAmount: 0,
      netTotal: 0,
    };
  }
  

  useEffect(() => {
    resetmodal();
  }, [data, setValue]);


function reloadmodal() {
  console.log(fetchOrder, selectedData);
console.log(selectedData?.purchaseDetails[0]?.product)
  if (fetchOrder && selectedData) {
    const mappedItems = selectedData?.purchaseDetails?.map((detail) => {
  const product = detail?.product || {};
  const unit = detail?.unit || {};
  const discount = detail?.discount || {};
  const tax = detail?.tax || {};

  return {
    product: product.guid || null,
    code: product.code || "",
    hsnCode: product.hsnCode || "",
    batch: detail.batch || "",
    expiry: dayjs(detail.expiry),
    unit: unit.guid || null,
    quantity: detail.quantity || 0,
    price: detail.price || 0,
    mrp: detail.mrp || 0,
    foc: detail.foc || 0,
    discountPercentage: discount.percentage || null,
    discountAmount: detail.discountAmount || 0,
    taxPercentage: tax.percentage || null,
    gross: detail.grossAmount || 0,
    taxAmount: detail.taxAmount || 0,
    netTotal: detail.netAmount || 0,
  };
});

    reset({
      entrynumber:getValues("entrynumber"), 
      remarks: selectedData.remarks || "",
      shipmentNo: selectedData.shipmentNo || "",
      shipmentTerms: selectedData.shipmentTerms || "",
      invoiceNo: selectedData.invoiceNo || "",
      addition: selectedData.addition || 0,
      subtraction: selectedData.discount || 0,
      round: selectedData.roundOff || 0,
      grossTotal: selectedData.grossTotal || 0,
      discountTotal: selectedData.discountTotal || 0,
      taxTotal: selectedData.taxTotal || 0,
      netTotal: selectedData.netTotal || 0,
      paymentType: selectedData.purchasePaymentType || 0,
      supplier: selectedData.supplier?.guid || null,
      date: dayjs(selectedData.date) || dayjs(),
      invoiceDate: dayjs(selectedData.invoiceDate) || dayjs(),
      duedate: dayjs(selectedData.duedate) || dayjs(),
      items: mappedItems?.length > 0 ? mappedItems : [getBlankItem()],
    });
  }
}


  useEffect(() => {
  if (fetchOrder && selectedData) {
    reloadmodal();
  }
}, [fetchOrder, selectedData]);


const handleFilterClick = async () => {
  try {
    console.log(referenceTypeValue);
    if(referenceTypeValue  !== 0) {
    const response = await getPurchaseByTransType(branch, referenceTypeValue -1);
    setFetchOrder(true); // make sure this is a boolean
console.log(response.data);
    const refNo = getValues("refNo")?.trim();

    if (refNo) {
      const filtered = response.data?.filter(item =>
        item.entrynumber?.toString().includes(refNo)
      );

      if (filtered.length > 0) {
        setSelectedData(filtered[0]);  // ✅ use first match
      } else {
        toast.error("No matching data found for Ref No");
        setSelectedData(null);
      }
    } else {
      setPurchaseData(purchaseData); // fallback
      setSelectedData(null);
    }
  }
  } catch (error) {
    console.error("Error fetching purchase data:", error);
  }
};

  useEffect(() => {
    handleSupplierList();
  }, [supplierList]);

  const handleProductsList = async () => {
    try {
      const formattedProducts = productList
        ?.filter((product) => product.isStockItem === true)
        .map((product) => ({
          label: product.name,
          value: product.guid,
        }));
      setProducts(formattedProducts);
    } catch (error) {
      console.error(
        "Error fetching products",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleAddRow = () => {
    append({
      batch: "0",
      code: "0",
      discountAmount: "0.0",
      discountPercentage: "0.0",
      expiry: dayjs().format("YYYY-MM-DD"),
      foc: "0.0",
      gross: "0.0",
      hsnCode: 0,
      mrp: "0.0",
      netTotal: "0.0",
      price: "0.0",
      quantity: "0",
      taxAmount: "0.0",
      taxPercentage: "0",
      unit: "",
      product: null,
    });
    focusProduct();
  };

  const handleFormSubmit = async (formdata) => {
    console.log(formdata.entryNumber);
    console.log(formdata.entrynumber);
    const objPurchase = new PurchaseClass();
    if (mode === "edit") {
      objPurchase.guid = data.guid;
      objPurchase.id = data.id;
    }
    const objfinance = new FinancialYear();
    objfinance.id = branchsettings?.defaultFinancialYearID;

    objPurchase.branch = branch;
    objPurchase.date = formdata.date
      ? dayjs(formdata.date).format("YYYY-MM-DDTHH:mm:ss")
      : dayjs().format("YYYY-MM-DD");
    objPurchase.purchasePaymentType = formdata.paymentType;
    objPurchase.purchaseTransType = 2;

    // Get supplier data asynchronously

    objPurchase.supplier = supplierList?.find(
      (e) => e.guid == formdata.supplier
    );
    objPurchase.updatedUser = `{${userId?.id}}`;
    objPurchase.invoiceDate = formdata.invoiceDate
      ? dayjs(formdata.invoiceDate).format("YYYY-MM-DDTHH:mm:ss")
      : dayjs().format("YYYY-MM-DD");
    objPurchase.invoiceNo = formdata.invoiceNo || "0";
    objPurchase.refNo = formdata.refNo || "0";
    objPurchase.shipmentNo = formdata.shipmentNo || "0";
    objPurchase.shipmentTerms = formdata.shipmentTerms || "";
    objPurchase.remarks = formdata.remarks || "";
    objPurchase.addition = formdata.addition || 0.0;
    objPurchase.discount = formdata.subtraction || 0.0;
    objPurchase.roundOff = formdata.round || 0.0;
    objPurchase.grossTotal = totalGross || 0;
    objPurchase.discountTotal = totalDiscount || 0.0;
    objPurchase.taxTotal = totalTax || 0.0;
    objPurchase.netTotal = totalNet || 0.0;
    objPurchase.referenceType = formdata.referenceType || 0;
    objPurchase.entrynumber = formdata.entrynumber || 0;
    objPurchase.duedate = formdata.duedate
      ? dayjs(formdata.duedate).format("YYYY-MM-DDTHH:mm:ss")
      : dayjs().format("YYYY-MM-DD");

    objPurchase.financialYear = objfinance;
    objPurchase.Company = companyInfolist[0];

    const detailObj = formdata?.items?.map((e) => {
      const defaultDiscountobj = new DiscountClass();
      const defaultTaxobj = new TaxClass();

      let product;
      const productValue = e.product || e.product.value;

      product = productList?.find((item) => item.guid == productValue);
      const unit = unitList?.find((item) => item.guid == e.unit);
      const discountValue = discountData?.find(
        (discount) => discount.value === e.discountPercentage
      );
      const discount = discountValue
        ? discountList?.find((item) => item.guid == discountValue.guid)
        : defaultDiscountobj;
      const taxValue = taxData?.find((tax) => tax.value === e.taxPercentage);
      const tax = taxValue
        ? taxList?.find((item) => item.guid == taxValue.guid)
        : defaultTaxobj;

      const expiry = e.expiry
        ? dayjs(e.expiry).format("YYYY-MM-DDTHH:mm:ss")
        : dayjs().format("YYYY-MM-DDTHH:mm:ss");

      const detailObj = {
        product,
        unit,
        batch: e.batch,
        expiry,
        quantity: e.quantity,
        price: e.price,
        mrp: e.mrp,
        foc: e.foc,
        taxAmount: e.taxAmount,
        grossAmount: e.gross,
        netAmount: e.netTotal,
        discountAmount: e.discountAmount,
        discount,
        tax,
      };

      return detailObj;
    });
    objPurchase.purchaseDetails = detailObj;
    try {
      const response = await addEditPurchase(objPurchase);
      if (response) {
        toast.success("Success");
        handleRefresh(); // Refresh the list
        handleClose(); // Close the modal

             if (printAfterSubmit) {
        printA4Function();      // 👈 only called if user clicked "Save & Print"
        setPrintAfterSubmit(false); // reset flag
      }
    }
    } catch (error) {
      toast.error(error?.response?.data?.Message || "something went wrong");
      console.error("Error handling :", error?.response?.data?.Message);
    }
  };
     const handlePrint = () => {
  printA4Function(); // Only A4 print allowed
};

    const printA4Function = async() => {
    const form = document.getElementById("invoice-content");
  
    if (!form) {
      console.error("Element with ID 'invoice-content' not found.");
      return;
    }

    const company = companyInfolist.length > 0 ? companyInfolist[0] : {}; // Assuming single company info

    // Extract company details
    const companyName = company.name || "Company Name";
    const companyAddress1 = company.address1 || "";
    const companyAddress2 = company.address2 || "";
    const companyAddress3 = company.address3 || "";
    const companyPhone = company.phone || "";
    const companyVAT = company.tin || "";
    // Extract values from form inputs
    

    
    
    
    const entryNumber = form.querySelector("input[name='entrynumber']")?.value || "";
   
    const dateValue = watch("date") || new Date().toISOString();
    const date = new Date(dateValue).toLocaleDateString("en-GB"); // Format date as DD/MM/YYYY
const deliveryDate = new Date(watch("deliveryDate")).toLocaleDateString("en-GB");
const invDateValue = watch("invdate") || new Date().toISOString();
  const invoiceDate = new Date(invDateValue).toISOString();
  const supplierGuid = watch("supplier");
const supplierObj = supplierList.find(sup => sup.guid === supplierGuid) || {};
const supplierName = supplierObj.name || supplierObj.ledger || "N/A";
const supplierAddress1 = supplierObj.address1 || "";
const supplierMobile = supplierObj.mobile || "";
    const fields = watch("items") || [];
const selectedPaymentValue = watch("paymentType");
const selectedPayment = paymentType.find(p => p.value === selectedPaymentValue);
const paymentLabel = selectedPayment?.label || "N/A";

// the bill's own totals (billCalc): bill discount, addition and round off included
const discount = totalDiscount;
const taxTotal = totalTax;
const netTotal = totalNet;

// Store the totals in React Hook Form
setValue("discount", discount.toFixed(2));
setValue("taxTotal", taxTotal.toFixed(2));
setValue("netTotal", netTotal.toFixed(2));

console.log({ totalDiscount, totalTax, totalNet });

  
    // Extract table data
  

  const tableRows = Array.from(form.querySelectorAll("table tbody tr")).map(row => {
    // Query the react-select component for the current row
    const selectContainer1 = row?.querySelector('.css-b62m3t-container');
    const selectContainer = selectContainer1?.querySelector('.react-select__control');
    const selectContainer3 = selectContainer?.querySelector('.react-select__value-container');
    const selectedValueDiv = selectContainer3?.querySelector('.react-select__single-value');
  
    // Extract the text or value of the selected option
    const selectedValue = selectedValueDiv?.textContent || "N/A";
  
  //   // Extract other values from the row (quantity, rate, total)
    return {
      description: selectedValue,
      code: row.querySelector("td:nth-child(2) input")?.value?.trim() || "",
      qty: parseInt(row.querySelector("td:nth-child(7) input")?.value?.trim()) || 0,
      rate: parseFloat(row.querySelector("td:nth-child(8) input")?.value?.trim()) || 0.00,
      total: parseFloat(row.querySelector("td:nth-child(14) input")?.value?.trim()) || 0.00,
      tax: parseFloat(row.querySelector("td:nth-child(12) input")?.value?.trim()) || 0.00,
      discount: parseFloat(row.querySelector("td:nth-child(13) input")?.value?.trim()) || 0.00,
    };
  });






  console.log(tableRows,"lkkk");


    const printableContent = `
  <html>
    <head>
     
      <style>
       * { box-sizing: border-box; }
        html, body {
          height: 100%;
          margin: 0;
          padding: 20px;
          font-family: Arial, sans-serif;
          font-size: 12px;
        }

        .container {
          display: flex;
          flex-direction: column;
          height: 100%;
        }
        table { width: 100%; border-collapse: collapse; margin-top: 10px; }
        .header { text-align: center; margin-bottom: 10px; }
        th, td { border: 1px solid #000; padding: 6px; font-size: 12px; text-align: center; }
        .info-table { width: 100%; margin-bottom: 10px; }
        .info-table .text-right {  text-align: left;       /* Make content left-aligned */
  padding-left: 28%;  }
        .info-table td { border: none; font-size: 12px; padding: 4px; text-align: left;  vertical-align: top; }
        .totals-section
         { display: flex;  justify-content: space-between; }
             .content {
          flex: 1;
        } 
        .additions { width: 60%; border: 1px solid #000; height: 100px; padding: 10px; font-size: 12px; }
        .totals-table { width: 35%; border-collapse: collapse; }
        .totals-table td { border: 1px solid #000; padding: 6px; font-size: 12px; text-align: right; }
        .totals-table td.label { text-align: left; width: 70%; }
           @media print {
          html, body {
            height: 100%;
            margin: 0;
            padding: 0;
          }
          .container {
            padding: 20px;
          }
        }
      </style>
    </head>
    <body>
     <div class="container">
      <div class="header">
        <h2>${companyName}</h2>
        
      <p>${companyAddress1}, ${companyAddress2}, ${companyAddress3}</p>
        Email: ${company.email || "-"} | PH: ${companyPhone}
      </div>

      <table class="info-table">
        <tr>
          <td><strong>Supplier : </strong> ${supplierName}</td>
        <td class="text-right"><strong>PI No : </strong>${entryNumber}</td>
        </tr>
        <tr>
          <td><strong>Address : </strong> ${supplierAddress1}</td>
         <td class="text-right"><strong>Date : </strong> ${date}</td>
        </tr>
        <tr>
          <td><strong>Mobile No : </strong> ${supplierMobile}</td>
         <td class="text-right"><strong> Invoice No:</strong> ${form.querySelector("input[name='invoiceNo']")?.value || ""} </td>
        </tr>
        <tr>
          <td><strong>TIN : </strong>${companyVAT} </td>
         <td class="text-right"><strong>Payment Mode : </strong> ${paymentLabel}</td>
        </tr>
      </table>

      <h3 style="text-align: center;">PURCHASE INVOICE</h3>
   <div class="content">
      <table>
        <thead>
          <tr>
            <th>S.No</th>
            <th>Code</th>
            <th>Particulars</th>
            
            <th>Qty</th>
            <th>Rate</th>
            <th>Discount</th>
        
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          ${tableRows.map((row, index) => `
            <tr>
              <td>${index + 1}</td>
              <td>${row.code || "-"}</td>
              <td>${row.description}</td>
            
              <td>${row.qty}</td>
              <td>${row.rate.toFixed(2)}</td>
              <td>${(row.discount || 0).toFixed(2)}</td>
            
              <td>${row.total.toFixed(2)}</td>
            </tr>`).join("")}
        </tbody>
      </table>
 </div>

<hr style="margin-top: 20px; border: none; border-top: 2px solid #000; width: 100%;" />


      <div class="totals-section">
        <div class="additions">
          <strong>Additions:</strong><br>
          ${form.querySelector("textarea[name='additions']")?.value || ""}
        </div>
        <table class="totals-table">
          <tr>
            <td class="label">TOTAL:</td>
            <td>${totalGross.toFixed(2)}</td>
          </tr>
          <tr>
            <td class="label">DISCOUNT:</td>
            <td>${discount.toFixed(2)}</td>
          </tr>
          ${billCalc.addition ? `<tr><td class="label">ADDITION:</td><td>${billCalc.addition.toFixed(2)}</td></tr>` : ""}
          <tr><td class="label">VAT:</td><td>${taxTotal.toFixed(2)}</td></tr>
          ${billCalc.roundOff ? `<tr><td class="label">ROUND OFF:</td><td>${(-billCalc.roundOff).toFixed(2)}</td></tr>` : ""}
     
          <tr>
            <td class="label">NET TOTAL:</td>
            <td>${netTotal.toFixed(2)}</td>
          </tr>
        </table>
      </div>
         </div>
    </body>
  </html>
`;

  
    // Create an iframe for better printing
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0px";
    iframe.style.height = "0px";
    iframe.style.border = "none";
    document.body.appendChild(iframe);
  
    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(printableContent);
    doc.close();
  
    iframe.contentWindow.focus();
    setTimeout(() => {
      iframe.contentWindow.print();
      iframe.contentWindow.onafterprint = () => document.body.removeChild(iframe);
    }, 500);
  };
  
  return (
    <div>
      <div
        className="modal fade show"
        style={{ display: "block" }}
        tabIndex="-1"
      >
        <div className="modal-dialog add-centered">
          <div className="modal-content">
            <div className="page-wrapper p-0 m-0">
              <div className="content p-0">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>
                      {" "}
                      {mode === "edit"
                        ? "Edit Purchase Invoice"
                        : "Add Purchase Invoice"}
                    </h4>
                  </div>
                  <button type="button" className="close" onClick={handleClose}>
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="card">
                  <div className="card-body">
                    <form id="invoice-content" onSubmit={handleSubmit(handleFormSubmit)}>
                      <div className="row">
                        {/* row1 */}
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label className="form-label">Entry No.</label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("entrynumber")}
                              required
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label>Date</label>
                            <div className="input-groupicon calender-input">
                              <Calendar className="info-img" />
                              <Controller
                                control={control}
                                name="date"
                                render={({ field: { onChange, value } }) => (
                                  <DatePicker
                                    className="datetimepicker"
                                    value={value ? dayjs(value) : dayjs()}
                                    format="DD-MM-YYYY"
                                    onChange={(date) =>
                                      onChange(
                                        date ? date.format("YYYY-MM-DD") : null
                                      )
                                    }
                                  />
                                )}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label className="form-label">Remarks</label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("remarks")}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label className="form-label">
                              Payment Type<span className="text-danger">*</span>
                            </label>
                            <div className="row">
                              <Controller
                                control={control}
                                name={`paymentType`}
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    classNamePrefix="react-select"
                                    options={paymentType}
                                    value={paymentType?.find(
                                      (paymentType) =>
                                        paymentType?.value === value
                                    )}
                                    onChange={(selectedOption) =>
                                      onChange(selectedOption.value)
                                    }
                                    styles={{
                                      menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    required
                                  />
                                )}
                              />
                            </div>
                          </div>
                        </div>

                        {/* row 2 */}
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label className="form-label">
                              Reference Type
                              <span className="text-danger">*</span>
                            </label>
                            <div className="row">
                              <Controller
                                control={control}
                                name={`referenceType`}
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    classNamePrefix="react-select"
                                    options={referenceType}
                                    value={referenceType?.find(
                                      (reference) => reference?.value === value
                                    )}
                                    onChange={(selectedOption) =>
                                      onChange(selectedOption.value)
                                    }
                                    required
                                  />
                                )}
                              />
                              <div className="col-lg-2 col-sm-2 col-2 ps-0"></div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                                                  <div className="input-blocks">
                                                    <label className="form-label">Reference No.</label>
                                                    <div className="row">
                                                    <div className="col-lg-10 col-sm-10 col-10">
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      {...register("refNo")}
                                                    />
                                                    </div>
                                                  
                                                  <div className="col-lg-2 col-sm-2 col-2 ps-0">
                                                        <div className="add-icon tab">
                                                          <Link to="#" onClick={handleFilterClick}>
                                                            <ArrowDown className="feather-plus-circles" />
                                                          </Link>
                                                        </div>
                                                    </div>
                                                    </div>
                                                    </div>
                                                </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label>Invoice Date</label>
                            <div className="input-groupicon calender-input">
                              <Calendar className="info-img" />
                              <Controller
                                control={control}
                                name="invoiceDate"
                                render={({ field: { onChange, value } }) => (
                                  <DatePicker
                                    className="datetimepicker"
                                    value={value ? dayjs(value) : dayjs()} // Set value or default to today
                                    format="DD-MM-YYYY"
                                    onChange={(date) =>
                                      onChange(
                                        date ? date.format("YYYY-MM-DD") : null
                                      )
                                    } // Update on change
                                  />
                                )}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label className="form-label">Invoice No.</label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("invoiceNo")}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks add-product">
                            <label>
                              Supplier Name
                              <span className="text-danger">*</span>
                            </label>
                            <div className="row">
                              <div className="col-lg-10 col-sm-10 col-10">
                                <Controller
                                  control={control}
                                  name={`supplier`}
                                  render={({ field: { onChange, value } }) => (
                                    <Select
                                      classNamePrefix="react-select"
                                      options={supplierData}
                                      value={supplierData?.find((supplier) => supplier?.value === value) || null}
                                      onChange={(selectedOption) =>
                                          onChange(selectedOption ? selectedOption.value : null)}
                                      styles={{
                                        menu: (provided) => ({
                                          ...provided,
                                          zIndex: 9999,
                                        }),
                                      }}
                                      required
                                    />
                                  )}
                                />
                              </div>
                              <div className="col-lg-2 col-sm-2 col-2 ps-0">
                                <div className="add-icon tab">
                                  <Link
                                    to="#"
                                    onClick={() => {
                                      setModalOpen(true);
                                    }}
                                  >
                                    <PlusCircle className="feather-plus-circles" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* row 3 */}

                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label className="form-label">Shipment No.</label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("shipmentNo")}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label className="form-label">Shipment Term</label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("shipmentTerms")}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks">
                            <label>Due Date</label>
                            <div className="input-groupicon calender-input">
                              <Calendar className="info-img" />
                              <Controller
                                control={control}
                                name="duedate"
                                render={({ field: { onChange, value } }) => (
                                  <DatePicker
                                    className="datetimepicker"
                                    value={value ? dayjs(value) : dayjs()} // Set value or default to today
                                    format="DD-MM-YYYY"
                                    onChange={(date) =>
                                      onChange(
                                        date ? date.format("YYYY-MM-DD") : null
                                      )
                                    } // Update on change
                                  />
                                )}
                              />
                            </div>
                          </div>
                        </div>
                        {/* <div className="row">
                          <div className="col-lg-10">
                            <div className="input-blocks">
                              <label>Product Name</label>
                              <input
                                type="text"
                                placeholder="Please type product code and select"
                              />
                            </div>
                          </div>
                        </div> */}
                        {/* end of rows */}
                      </div>

                      <div className="table-responsive  no-pagination table-container">
                        <table className="table tablezind">
                          <thead>
                            <tr>
                              <th className="sticky-header">
                                Description
                                <span className="text-danger">*</span>
                              </th>
                              <th className="sticky-header">Item Code</th>
                              <th className="sticky-header">HSN Code</th>
                              <th className="sticky-header">Unit</th>
                              <th className="sticky-header">Batch</th>
                              <th className="sticky-header">Exp Date</th>
                              <th className="sticky-header">
                                Quantity<span className="text-danger">*</span>
                              </th>
                              <th className="sticky-header">
                                Price <span className="text-danger">*</span>
                              </th>
                              <th className="sticky-header">MRP </th>
                              <th className="sticky-header">FOC</th>
                              <th className="sticky-header">Gross</th>
                              <th className="sticky-header">Discount %</th>
                              <th className="sticky-header">Discount Amount</th>
                              {branchsettings?.disableTaxInSale == false && (
                                <th className="sticky-header">Tax %</th>
                              )}
                              {branchsettings?.disableTaxInSale == false && (
                                <th className="sticky-header">Tax Amount</th>
                              )}
                              <th className="sticky-header">Net Amount</th>
                              <th className="sticky-header">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {fields.map((obj, index) => {
                              return (
                                <tr key={obj.id}>
                                  <td>
                                    <Controller
                                      control={control}
                                      name={`items[${index}].product`}
                                      rules={{
                                        required: "Product is required",
                                        validate: (value) => {
                                          const selectedProducts = watch(
                                            "items"
                                          )?.map((item) => item.product); // Get all selected products
                                          const isDuplicate =
                                            selectedProducts?.filter(
                                              (product) => product === value
                                            )?.length > 1;
                                          return (
                                            !isDuplicate ||
                                            "Duplicate product selected!"
                                          );
                                        },
                                      }}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <Select
                                          classNamePrefix="react-select"
                                          options={products}
                                          ref={selectRef}
                                          value={
                                            products?.find((option) => option.value === value) || null
                                          }
                                          onChange={(selectedOption) => {
                                            onChange(selectedOption ? selectedOption.value : null);
                                            handleEachProductfetch(
                                              selectedOption,
                                              index
                                            );
                                          }}
                                          styles={{
                                            menu: (provided) => ({
                                              ...provided,
                                              zIndex: 9999,
                                              position: "relative",
                                            }),
                                          }}
                                        />
                                      )}
                                    />
                                    {errors.items &&
                                      errors.items[index]?.product && (
                                        <span className="text-danger small">
                                          {errors.items[index].product.message}
                                        </span>
                                      )}
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].code`)}
                                      disabled
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].hsnCode`)}
                                      disabled
                                    />
                                  </td>
                                  <td>
                                    <Controller
                                      control={control}
                                      name={`items[${index}].unit`}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <Select
                                          classNamePrefix="react-select"
                                          options={unitData}
                                          value={unitData?.find(
                                            (option) => option.value === value
                                          )}
                                          onChange={(selectedOption) => {
                                            onChange(selectedOption.value);
                                          }}
                                          isDisabled={true}
                                        />
                                      )}
                                    />
                                  </td>

                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].batch`)}
                                    />
                                  </td>
                                  <td>
                                    <Controller
                                      control={control}
                                      name={`items[${index}].expiry`}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <DatePicker
                                          className="datetimepicker"
                                          placeholder={
                                            value ? dayjs(value) : dayjs()
                                          }
                                          value={value ? dayjs(value) : dayjs()}
                                          format="DD-MM-YYYY"
                                          onChange={(date) => onChange(date)}
                                        />
                                      )}
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].quantity`, {
                                        required: "Quantity is required",
                                        validate: (value) =>
                                          (!isNaN(value) && value > 0) ||
                                          "Quantity must be a positive number",
                                      })}
                                    />
                                    {errors.items &&
                                      errors.items[index]?.quantity && (
                                        <span className="text-danger small">
                                          {errors.items[index].quantity.message}
                                        </span>
                                      )}
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].price`, {
                                        required: "Price is required",
                                        validate: (value) =>
                                          (!isNaN(value) && value > 0) ||
                                          "Price must be a positive number",
                                      })}
                                    />
                                    {errors.items &&
                                      errors.items[index]?.price && (
                                        <span className="text-danger small">
                                          {errors.items[index].price.message}
                                        </span>
                                      )}
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].mrp`, {
                                        validate: (value) =>
                                          (!isNaN(value) && value >= 0) ||
                                          "MRP must be zero or more",
                                      })}
                                    />
                                    {errors.items &&
                                      errors.items[index]?.mrp && (
                                        <span className="text-danger small">
                                          {errors.items[index].mrp.message}
                                        </span>
                                      )}
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].foc`, {
                                        validate: (value) =>
                                          (!isNaN(value) && value >= 0) ||
                                          "FOC must be zero or more",
                                      })}
                                    />
                                    {errors.items &&
                                      errors.items[index]?.foc && (
                                        <span className="text-danger small">
                                          {errors.items[index].foc.message}
                                        </span>
                                      )}
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].gross`)}
                                      disabled
                                    />
                                  </td>
                                  <td>
                                    <Controller
                                      control={control}
                                      name={`items[${index}].discountPercentage`}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <Select
                                          classNamePrefix="react-select"
                                          options={discountData}
                                          isClearable
                                          value={
                                            discountData?.find(
                                              (option) => option.value === value
                                            ) ?? null
                                          }
                                          onChange={(selectedOption) =>
                                            onChange(
                                              selectedOption
                                                ? selectedOption.value
                                                : null
                                            )
                                          }
                                          styles={{
                                            menu: (provided) => ({
                                              ...provided,
                                              zIndex: 9999,
                                              position: "relative",
                                            }),
                                          }}
                                        />
                                      )}
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(
                                        `items[${index}].discountAmount`
                                      )}
                                      disabled
                                    />
                                  </td>
                                  {branchsettings?.disableTaxInSale ==
                                    false && (
                                    <td>
                                      <Controller
                                        control={control}
                                        name={`items[${index}].taxPercentage`}
                                        render={({
                                          field: { onChange, value },
                                        }) => (
                                          <Select
                                            classNamePrefix="react-select"
                                            options={taxData}
                                            placeholder="select"
                                            isClearable
                                            value={taxData?.find(
                                              (option) => option.value === value
                                            )}
                                            onChange={(selectedOption) => {
                                              onChange(
                                                selectedOption
                                                  ? selectedOption.value
                                                  : null
                                              );
                                            }}
                                            styles={{
                                              menu: (provided) => ({
                                                ...provided,
                                                zIndex: 9999,
                                                position: "relative",
                                              }),
                                            }}
                                          />
                                        )}
                                      />
                                    </td>
                                  )}
                                  {branchsettings?.disableTaxInSale ==
                                    false && (
                                    <td>
                                      <input
                                        type="text"
                                        className="form-control"
                                        {...register(
                                          `items[${index}].taxAmount`
                                        )}
                                        disabled
                                      />
                                    </td>
                                  )}
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register(`items[${index}].netTotal`)}
                                      disabled
                                    />
                                  </td>
                                  <td>
                                    <Link
                                      className="confirm-text p-2"
                                      onClick={() => handleRemove(index)}
                                    >
                                      <i
                                        data-feather="trash-2"
                                        className="feather-trash-2"
                                      ></i>
                                    </Link>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>

                      <div>
                        <div className="col-lg-2 col-sm-2 col-2 ps-0 ">
                          <button
                            className=" btn btn-dark add-icon tab  mt-3 "
                            type="button"
                            onClick={handleAddRow}
                          >
                            <PlusCircle className="feather-plus-circles" />
                          </button>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className=" col-4 ">
                          <div className="input-blocks">
                            <label>Addition</label>
                            <div className="input-groupicon select-code">
                              <input
                                type="number"
                                step="any"
                                min={0}
                                className="form-control p-2"
                                defaultValue={0}
                                {...register(`addition`)}
                              />
                              {errors.addition && (
                                <span className="text-danger small mt-1">
                                  {errors.addition.message}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className=" col-4 ">
                          <div className="input-blocks">
                            <label>Discount</label>
                            <div className="input-groupicon select-code">
                              <input
                                type="number"
                                step="any"
                                min={0}
                                className="form-control p-2"
                                defaultValue={0}
                                {...register(`subtraction`, {
                                  validate: (value) => {
                                    const discount = safeNumber(value);
                                    const totalNetAfterDiscount =
                                      totalNet - discount;
                                    if (discount < 0) {
                                      return "Discount value should not be negative.";
                                    } else if (totalNetAfterDiscount < 0) {
                                      return "Please enter a discount value that does not exceed the Net Total.";
                                    }
                                    return true;
                                  },
                                })}
                              />
                              {errors.subtraction && (
                                <span className="text-danger small mt-1">
                                  {errors.subtraction.message}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className=" col-4 ">
                          <div className="input-blocks">
                            <label>Round Off</label>
                            <div className="input-groupicon select-code">
                              <input
                                type="number"
                                step="any"
                                min={0}
                                className="form-control p-2"
                                defaultValue={0}
                                {...register(`round`, {
                                  validate: (value) => {
                                    const round = safeNumber(value);
                                    const totalNetAfterRound = totalNet - round;
                                    return (
                                      totalNetAfterRound >= 0 ||
                                      "Please enter a round-off value that does not exceed Net Total."
                                    );
                                  },
                                })}
                              />
                              {errors.round && (
                                <span className="text-danger small mt-1">
                                  {errors.round.message}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-4 ms-auto">
                          <div className="total-order w-100 max-widthauto m-auto mb-4">
                            <ul>
                              <li>
                                <h4>Gross</h4>
                                <h5> {totalGross?.toFixed(decimalpoints)}</h5>
                              </li>
                              <li>
                                <h4>Discount</h4>
                                <h5>{totalDiscount?.toFixed(decimalpoints)}</h5>
                              </li>
                              <li>
                                <h4>Tax Total</h4>
                                <h5> {totalTax?.toFixed(decimalpoints)}</h5>
                              </li>
                              <li>
                                <h4>Net Total</h4>
                                <h5> {totalNet?.toFixed(decimalpoints)}</h5>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-lg-12 text-end">
                                              <button
  type="submit"
  className="btn btn-cancel add-cancel me-3"
  onClick={() => setPrintAfterSubmit(true)} // 👈 set flag before submit
>
  Save & Print
</button>
                          <button
                            type="button"
                            className="btn btn-cancel add-cancel me-3"
                            onClick={() => resetmodal()}
                          >
                            Reset
                          </button>
                          <button
                            className="btn btn-submit add-sale"
                            type="submit"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalOpen && (
        <SupplierModal
          mode="add"
          data={{}}
          handleClose={() => setModalOpen(false)}
          handleRefresh={() => {}}
        />
      )}
    </div>
  );
};
export default PurchaseInvoiceModal;
